{
  "replacementComponentList": [],
  "replacementComponentListTotalCount": 0,
  "replacementComponentListErrorsCount": 0,
  "replacementComponentListSortExpression": null,
  "replacementComponentListFilterExpression": null,    
  "replacementComponentListPaging": {
    "page": 1,
    "offset": 50
  }    
}